<script setup lang="ts">
const { LocalConfigurationStore } = stores()

const banner = computed(() => LocalConfigurationStore.value?.siteInfo?.banner)

const bannerImg = ref<string[]>(banner.value?.map((b) => `banner-${b.code}`) ?? [])
const { imgs } = useImageLoaderTracker(bannerImg)
</script>

<template>
  <div>
    <PvCarousel
      :value="banner"
      :num-visible="1"
      :num-scroll="1"
      :show-navigators="false"
      :show-indicators="banner && banner.length > 1"
      circular
      :autoplay-interval="banner?.length && 8000"
    >
      <template #item="{ data }">
        <PvSkeleton
          v-if="!imgs.find((i) => i.id === `banner-${data.code}`)?.completed"
          class="w-full aspect-[5/7] md:aspect-[7/3]"
        />
        <ClientOnly>
          <div
            v-show="imgs.find((i) => i.id === `banner-${data.code}`)?.completed"
            :class="data.url && 'cursor-pointer'"
            @click="data.url && navigateTo(data.url, { external: true })"
          >
            <ImageComponent
              v-if="$viewport.match('sm')"
              :id="`banner-${data.code}`"
              :src="`/siteAssets/img|banners/${data?.files.mobile}`"
              class="w-full rounded"
            />

            <ImageComponent
              v-else
              :id="`banner-${data.code}`"
              :src="`/siteAssets/img|banners/${data?.files.desktop}`"
              class="w-full rounded"
            />
          </div>
        </ClientOnly>
      </template>
    </PvCarousel>
  </div>
</template>

<style>
.p-carousel-indicator-button {
  height: 5px;
  width: 50px;
  border-radius: 9999px;
}
</style>
